<script setup lang="ts">
import { House, PackageOpen, ShoppingBag, ReceiptText, UserRound } from 'lucide-vue-next'
const items = [
  { to: '/', label: '抽取', icon: House },
  { to: '/warehouse', label: '仓库', icon: PackageOpen },
  { to: '/store', label: '商城', icon: ShoppingBag },
  { to: '/orders', label: '订单', icon: ReceiptText },
  { to: '/profile', label: '我的', icon: UserRound }
]
</script>

<template>
  <nav class="bottom-nav" aria-label="主导航">
    <RouterLink v-for="item in items" :key="item.to" :to="item.to" class="nav-item">
      <component :is="item.icon" :size="22" :stroke-width="1.8" aria-hidden="true" />
      <span>{{ item.label }}</span>
    </RouterLink>
  </nav>
</template>

